<template>
    <div :style="headerContainerStyle" v-if="loggedIn" class="app-header">
        <div class="first-row">
            <div>
                <div class="line-right">
                    <div @click="$router.push('/').catch(() => {})">
                        <i class="home-icon material-icons-outlined">home</i>
                    </div>
                </div>

                <p
                    id="pagetitle"
                    class="meeussenheadertitle"
                    v-html="pageTitle"></p>
            </div>

            <div>
                <div
                    class="printer-selectors line-right"
                    v-show="printersByPaperKey.length">
                    <template v-for="type in printersByPaperKey">
                        <ui5-select
                            @change="printerChangedForPaperKey($event, type)">
                            <ui5-option
                                :value="null"
                                :key="null"
                                :selected="
                                    selectedPrinters[type.paperkey] &&
                                    selectedPrinters[type.paperkey].id == null
                                ">
                                Selecteer printer
                            </ui5-option>
                            <ui5-option
                                v-for="printer in type.printers"
                                :key="printer.id"
                                :value="printer.id"
                                :selected="
                                    selectedPrinters[type.paperkey] &&
                                    selectedPrinters[type.paperkey].id ==
                                        printer.id
                                ">
                                {{ getPrinterLabel(printer) }}
                            </ui5-option>
                        </ui5-select>
                    </template>
                </div>

                <div class="date-display line-right">{{ dateDisplay }}</div>

                <div class="user-name-logout">
                    <div>{{ userName }}</div>
                    <div class="log-out-container" @click="logOut">
                        <uil-signout />
                    </div>
                </div>
            </div>
        </div>
        <div class="second-row" v-show="tikklok.showActions && userLocation">
            <div v-show="tikklok.title.show">{{ tikklok.title.text }}</div>
            <div v-show="tikklok.breakTitle.show">
                {{ tikklok.breakTitle.text }}
            </div>

            <div class="clock-actions">
                <div
                    @click="startWorkdayAction()"
                    v-show="tikklok.showStartWorkDay">
                    <uil-play-circle title="Klik om uw werkdag te starten" />
                </div>
                <div
                    @click="stopWorkDayAction()"
                    v-show="tikklok.showStopWorkDay">
                    <uil-stop-circle title="Klik om uw werkdag te beëindigen" />
                </div>

                <div
                    @click="startBreakAction()"
                    v-show="tikklok.showStartBreak">
                    <uil-utensils title="Klik om uw pauze te starten" />
                </div>

                <div @click="stopBreakAction()" v-show="tikklok.showStopBreak">
                    <uil-utensils-alt title="Klik om uw pauze te beëindigen" />
                </div>

                <div @click="startSmokingBreakAction()">
                    <i
                        title="Klik om uw rookpauze te starten"
                        v-show="tikklok.showStartSmokingBreak"
                        class="material-icons">
                        smoking_rooms
                    </i>
                </div>

                <div @click="stopSmokingBreakAction()">
                    <i
                        title="Klik om uw rookpauze te beëindigen"
                        v-show="tikklok.showStopSmokingBreak"
                        class="material-icons">
                        smoke_free
                    </i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
    UilHome,
    UilPlayCircle,
    UilSignout,
    UilStopCircle,
    UilUtensils,
    UilUtensilsAlt,
} from '@iconscout/vue-unicons';
import Tikklok from '../shared/Tikklok';
import { getWeek } from '../helpers/DateHelper';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import _ from 'lodash';

export default {
    components: {
        UilHome,
        UilPlayCircle,
        UilSignout,
        UilStopCircle,
        UilUtensils,
        UilUtensilsAlt,
    },
    computed: {
        ...mapGetters({
            tikklok: 'currentUser/getTikklok',
            userLocation: 'currentUser/getUserLocation',
            loggedIn: 'currentUser/isValidLogin',
        }),
        printersByPaperKey() {
            if (!this.printers) {
                return [];
            }

            const visible = this.printers.filter(
                (x) => x.label && x.label.length
            );
            const grouped = _.groupBy(visible, 'paperkey');
            return Object.entries(grouped).map((x) => {
                return { paperkey: x[0], printers: x[1] };
            });
        },
        userName() {
            return this.$store.getters['currentUser/getUserName'];
        },
        dateDisplay() {
            const today = new Date();
            const weekNr = getWeek(today, 1);  // ISO 8601: weeks start on Monday (dowOffset = 1)
            const weekDay = ((today.getDay() + 6) % 7) + 1;
            return 'W' + weekNr + '-' + weekDay;
        },
        erpConfig() {
            return Config;
        },
        printers() {
            return this.$store.getters['printers/getPrinters'] || [];
        },
        selectedPrinters: {
            get() {
                return this.$store.getters['printers/getSelectedPrinters'] || {};
            },
            set(printers) {
                this.$store.commit('printers/setSelectedPrinters', printers, {
                    root: true,
                });
            },
        },
        fetchInProgress() {
            return this.$store.getters['printers/getFetchInProgress'];
        },
        pageTitle: {
            get() {
                return this.$store.getters['general/getPageTitle'];
            },
            set(value) {
                this.$store.commit('general/setPageTitle', value, {
                    root: true,
                });
            },
        },
        headerContainerStyle() {
            const configColor = Config.backgroundcolor.toString();

            return {
                'border-top-color':
                    configColor && configColor.length ? configColor : '#DFA11A',
            };
        },
    },
    methods: {
        ...mapActions({
            fetchPrinters: 'printers/fetchPrinters',
        }),
        printerChangedForPaperKey(event, type) {
            let selectedId = event.detail.selectedOption.value;
            if (!selectedId || !selectedId.length) {
                selectedId = null;
            }
            const paperKey = type.paperkey;
            const selectedItem =
                this.printers.find((x) => x.id == selectedId) || null;
            const newSelectedPrinters = { ...this.selectedPrinters };
            newSelectedPrinters[paperKey] = selectedItem;
            this.selectedPrinters = newSelectedPrinters;
        },
        getPrinterLabel(printer) {
            if (printer.label && printer.label.length) {
                return printer.label;
            }
            if (printer.name && printer.name.length) {
                return printer.name;
            }
            return '#' + printer.id;
        },
        logOut() {
            sessionStorage.removeItem('sessionKey');
            sessionStorage.removeItem('vuex');
            localStorage.removeItem('vuex');
            this.$router.go(); //Reload to make sure Vuex persisted state doesn't restore the localStorage item
        },
        startWorkdayAction() {
            Tikklok.registerTime(() => {
                showInfoMessage('Werkdag is begonnen');
            });
        },
        stopWorkDayAction() {
            Tikklok.registerTime(() => {
                this.$store.commit('currentUser/hideActions', { root: true });
                showInfoMessage('Werkdag is beëindigd');
            });
        },
        startBreakAction() {
            Tikklok.registerTime(() => {
                showInfoMessage('Pauze is begonnen');
            });
        },
        stopBreakAction() {
            Tikklok.registerTime(() => {
                showInfoMessage('Pauze is beëindigd. Werkdag werd hervat');
            });
        },
        startSmokingBreakAction() {
            Tikklok.registerBreak(() => {
                showInfoMessage('Rookpauze is begonnen');
            });
        },
        stopSmokingBreakAction() {
            Tikklok.registerBreak(() => {
                showInfoMessage('Rookpauze is beëindigd');
            });
        },
        loadPrinters() {
            if (this.loggedIn && !this.fetchInProgress && this.printers.length < 1) {
                this.fetchPrinters();
            }
        },
    },
    mounted() {
        this.loadPrinters();
    },
    watch: {
        loggedIn() {
            this.loadPrinters();
        },
    },
};
</script>
